import { useBuyCart } from "@/Hooks/BuyCart/useBuyCart";
import type { MCart } from "@/Models/MCheckout/MCcart";
import type { Price } from "@/Type/Price";
import { formatMX } from "@/Utils/Fomat.price";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

type CartContextType = {
  AddCart: (
    IdSKU: string,
    TitleProduct: string,
    SoldByProduct: string,
    Categories: string,
    SubCategories: string,
    PriceProduct: Price,
    ImageProduct: string,
    LimitQuantity: number,
    Quantity?: Price,
    Country?: string,
    City?: string,
    ZipCode?: string,
    Cupon?: string
  ) => void;
  AddCartMoreQuantity: (
    IdSKU: string,
    TitleProduct: string,
    SoldByProduct: string,
    Categories: string,
    SubCategories: string,
    PriceProduct: Price,
    ImageProduct: string,
    LimitQuantity: number,
    Quantity?: Price,
    Country?: string,
    City?: string,
    ZipCode?: string,
    Cupon?: string
  ) => void;
  DeleteCart: (sku: string) => void;
  ViewCart: (sku: string) => void;
  taskCart: MCart[];
  ViewSubTotal: string;
  ViewCartQuantity: (sku: string, CSaleLimit: number) => boolean;
  UpdateCountCart: (IdSKU: string, quantity: Price) => void;
  SendBuyCartV2: (
    idSkus: string[],
    Country: string,
    City: string,
    ZipCode: number,
    Cupon: string
  ) => void;
  DeleteTaskClearContext: () => void;
};

const CheckoutContext = createContext<CartContextType | undefined>(undefined);

export const ContextCheckoutProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  //llamamos al hooks al que se encarga de guardar los datos y removerlos del carrito.
  const {
    addCheckoutSKU,
    AddCartGo,
    AddCartGoOne,
    DeleteCart,
    ViewCart,
    UpdateCountCart,
    SendBuyCartV2,
    DeleteTaskClear,
  } = useBuyCart();

  //const [taskCart, setTaskCart] = useState<MCart[]>([]);

  const taskCart = addCheckoutSKU ?? [];
  //console.log(taskCart, " --- ", addCheckoutSKU);

  const ViewSubTotal = formatMX(
    taskCart.reduce((a, b) => {
      const unitPrice = b.PriceProduct;
      return a + unitPrice * (b.Quantity ?? 1);
    }, 0)
  );

  const ViewCartQuantity = useCallback(
    (sku: string, CSaleLimit: number) => {
      const item = taskCart.find((i) => i.IdSKU === sku);
      if (item && item.Quantity! >= CSaleLimit) return true;
      return false;
    },
    [taskCart]
  );

  const AddCart = useCallback(
    (
      IdSKU: string,
      TitleProduct: string,
      SoldByProduct: string,
      Categories: string,
      SubCategories: string,
      PriceProduct: Price,
      ImageProduct: string,
      LimitQuantity: number
      //Quantity?: Price
    ) => {
      AddCartGoOne(
        IdSKU,
        TitleProduct,
        SoldByProduct,
        Categories,
        SubCategories,
        PriceProduct,
        ImageProduct,
        LimitQuantity
        //Quantity
      );
    },
    []
  );

  const AddCartMoreQuantity = useCallback(
    (
      IdSKU: string,
      TitleProduct: string,
      SoldByProduct: string,
      Categories: string,
      SubCategories: string,
      PriceProduct: Price,
      ImageProduct: string,
      LimitQuantity: number
      //Quantity?: Price
    ) => {
      AddCartGo(
        IdSKU,
        TitleProduct,
        SoldByProduct,
        Categories,
        SubCategories,
        PriceProduct,
        ImageProduct,
        LimitQuantity
        //Quantity
      );
    },
    []
  );

  const DeleteTaskClearContext = useCallback(() => DeleteTaskClear(), []);

  return (
    <CheckoutContext.Provider
      value={{
        AddCart,
        AddCartMoreQuantity,
        DeleteCart,
        ViewCart,
        taskCart,
        ViewSubTotal,
        ViewCartQuantity,
        UpdateCountCart,
        SendBuyCartV2,
        DeleteTaskClearContext,
      }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useContextCheckoutData = () => {
  const context = useContext(CheckoutContext);
  if (!context)
    throw new Error(
      "useContextCheckoutData must be used within a CheckoutContextProvider"
    );
  return context;
};
